import { CompleteOrderType } from '../../common/Types';
import { RootState } from '../reducers';

export function getActiveCollapsibleOrders(state: RootState): number[] {
    return state.collapsibles.ordersIds;
}

export function isOrderCollapsed(orderId?: number): (state: RootState) => boolean {
    return function (state: RootState): boolean {
        if (!state.collapsibles.ordersIds || !orderId) {
            return true;
        }

        return state.collapsibles.ordersIds.findIndex((oId) => oId === orderId) === -1;
    };
}

export function isPurchaseOrderCollapsed(orderId?: number): (state: RootState) => boolean {
    return function (state: RootState): boolean {
        if (!state.collapsibles.purchaseOrdersIds || !orderId) {
            return true;
        }

        return state.collapsibles.purchaseOrdersIds.findIndex((oId) => oId === orderId) === -1;
    };
}

export function isDemandOrderCollapsed(orderId?: number): (state: RootState) => boolean {
    return function (state: RootState): boolean {
        if (!state.collapsibles.demandOrdersIds || !orderId) {
            return true;
        }

        return state.collapsibles.demandOrdersIds.findIndex((oId) => oId === orderId) === -1;
    };
}

export function isGeneralReturnOrderCollapsed(orderId?: number): (state: RootState) => boolean {
    return function (state: RootState): boolean {
        if (!state.collapsibles.generalReturnOrdersIds || !orderId) {
            return true;
        }

        return state.collapsibles.generalReturnOrdersIds.findIndex((oId) => oId === orderId) === -1;
    };
}

export function getActiveCollapsibleGoods(state: RootState): number[] {
    return state.collapsibles.goodsIds;
}

export function isGoodsCollapsed(goodsId?: number): (state: RootState) => boolean {
    return function (state: RootState): boolean {
        if (!state.collapsibles.goodsIds || !goodsId) {
            return true;
        }

        return state.collapsibles.goodsIds.findIndex((gId) => gId === goodsId) === -1;
    };
}

/** Picks the collapsible list matching the row's order type, so a row can call one selector hook unconditionally. */
export function isCompleteOrderCollapsed(
    orderId?: number,
    orderType?: CompleteOrderType,
): (state: RootState) => boolean {
    switch (orderType) {
        case CompleteOrderType.Demand:
            return isDemandOrderCollapsed(orderId);
        case CompleteOrderType.GeneralReturn:
            return isGeneralReturnOrderCollapsed(orderId);
        default:
            return isOrderCollapsed(orderId);
    }
}
